/**
 * @param storeState
 * @returns {string} userNames
 */
export const getPrefillUserData = (storeState) => storeState.prefillUserData;
